import compose from 'ramda/src/compose';
import pathOr from 'ramda/src/pathOr';

const hasLength = compose(Boolean, pathOr(0, ['length']));

export default hasLength;
